function logoSlider() {

  const logoSlider = new Swiper('.js-logo-slider', {
    observer: true, 
    observeParents: true,
    loop: true,
    draggable: true,
    freeMode: {
      enabled: true,
      //sticky: true,
    },
    autoplay: {
      delay: 0,
      disableOnInteraction: false
    },
    speed: 4000,
    allowTouchMove: true,
    effect: 'slide',
    spaceBetween: 10,
    slidesPerView: 2,
    breakpoints: {
      600: {
        slidesPerView: 3,
        spaceBetween: 40,
        speed: 7000,
      },
      992: {
        slidesPerView: '5',
        spaceBetween: 100,
        speed: 7000,
      },
    },
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });

}


export default logoSlider;
